
<div class="list-bid-card">
    <form name="listBidInstructionForm" [formGroup]="listBidInstructionForm" (ngSubmit) = "onSubmitListBidInstructionForm()" style="margin-bottom: 35px;">
        <div style="display:flex">
            <div class="form-group" style="margin-right: 25px;">
                <div class="label">Property State:</div>
                <p-multiSelect #multiSelectState [options]="propertyState"
                    [(ngModel)]="selectedPropertyState" 
                    formControlName="propertyState"
                    [defaultLabel]="'Select One'"
                    filterBy="value,label">
                </p-multiSelect>
                <i>
                    <span 
                        [ngClass]="(selectedPropertyState && selectedPropertyState.length> 0) ? 'check-circle-green':'check-circle-gray'">
                        <i class="pi pi-check-circle"></i>
                    </span>
                </i>
            </div>
            <div class="form-group" style="margin-right: 18px;" >
                <div class="label">Trustee Name:</div>
                <p-multiSelect #multiSelectTrustee [options]="trustee" 
                    [(ngModel)]="selectedTrustee" 
                    formControlName="trustee"
                    [defaultLabel]="'Select One'">
                </p-multiSelect>
                <i>
                    <span 
                        [ngClass]="(selectedTrustee && selectedTrustee.length> 0) ? 'check-circle-green':'check-circle-gray'">
                        <i class="pi pi-check-circle"></i>
                    </span>
                </i>
            </div>
            <div class="form-group buttonSection">
                <button pButton  type="submit" label="View" [disabled]="!listBidInstructionForm.valid" class="margin-left-view-button"></button>&nbsp;
                <button pButton  type="button" label="Reset" (click)="resetForm()" class="ui-button-secondary margin-left"></button>
            </div>
        </div>      
    </form>

    <p-table #dt [value]="bidInstructions"
            [columns]="cols"
            autoLayout=true 
            [rows]="10"
            [paginator]="isPaginatorVisible()"
            [totalRecords]="records" 
            [rowsPerPageOptions]="[10,25,50,100]"
            dataKey="BidMatrixId"
            [globalFilterFields]="['StateCode', 'TrusteeName']" 
            rowExpandMode="multiple"
            [loading]="loadingSearchResult">

            <ng-template pTemplate="caption">
                <div style="float: right;display: flex;margin-top: -30px;" *ngIf="bidInstructions && bidInstructions.length >0">
                    <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
                    <input type="text" pInputText size="35" placeholder="Filter by: Property State and Trustee Name" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">&nbsp;&nbsp;
                    <div style="margin-top: 1.5%;font-size: 0.9em;">
                        {{records}} Records Found
                    </div>&nbsp;&nbsp;
                    <div>
                        <a href="{{excelUrl}}">
                            <i class="pi pi-download" style="font-size: 1.8em" ></i>
                        </a>
                    </div>
                </div>
            </ng-template>

            <ng-template  pTemplate="header">
                <tr #header *ngIf="formSubmitted">
                    <th style="width: 3em"></th>
                    <ng-container *ngFor="let col of cols">
                        <th *ngIf="col.showInHeader">
                            {{col.header}}
                        </th>
                    </ng-container>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr *ngIf="!loadingSearchResult && bidInstructions && formSubmitted  && bidInstructions.length === 0">
                    <td [attr.colspan]="10" class="center-align">No records found</td> 
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded">
                <tr>
                    <td>
                        <a href="#" [pRowToggler]="rowData" class="anchorClass">
                            <i [ngClass]="expanded ? 'fas fa-minus-square' : 'fas fa-plus-square'"></i>
                        </a>
                    </td>
                    <ng-container *ngFor="let col of columns">
                        <td *ngIf="col.showInHeader && col.field !='Action' && col.field != 'BidInstructionDocsIncluded'">
                            {{rowData[col.field]}}
                        </td>
                        <td *ngIf="col.showInHeader && col.field == 'BidInstructionDocsIncluded'">
                            {{rowData[col.field] == '1' ? 'Yes' : 'No'}}
                         </td>
                        <td *ngIf="col.showInHeader && col.field =='Action'">
                            <a (click)="showEditBidInstruction(rowData)" class="anchorClass">
                                <i class="pi  pi-pencil" style="font-size: 1.3em" ></i>
                            </a>&nbsp;
                        </td>
                    </ng-container>
                </tr>
            </ng-template>

            <ng-template pTemplate="rowexpansion" let-rowData  let-columns="columns" let-rowIndex="rowIndex">
                <tr>
                    <td  width="50%" colspan="3">
                        <div class="section-data" style="text-align: right;">
                            <span >Certificate of Sale – Altisource Copy Included?: </span>
                        </div>
                        <div class="section-data" style="text-align: right;">
                            <span >Certificate of Sale – Buyer’s Copy Included?: </span>
                        </div>
                        <div class="section-data" style="text-align: right;">
                            <span >Altisource Bid Sheet Included?: </span>
                        </div>
                        <div class="section-data" style="text-align: right;">
                            <span >Bid Instructions :</span>&nbsp;
                        </div>
                    </td>
                    <td width="50%" colspan="3">
                        <div class="section-data">
                            <span>{{rowData.COSAltisourceCopyIncluded == 1 ? 'Yes' : 'No'}}  </span>
                        </div>
                        <div class="section-data">
                            <span>{{rowData.COSBuyerCopyIncluded  == 1 ? 'Yes' : 'No'}}  </span>
                        </div>
                        <div class="section-data">
                            <span>{{rowData.AltisourceBidSheetIncluded  == 1 ? 'Yes' : 'No'}}  </span>
                        </div>
                        <div class="section-data">
                            <span>
                                <a (click)="downloadFile(rowData.BidMatrixId)">{{rowData.StateCode}}_BidInstructions ({{rowData.BiddingFileUploadedDate}})</a>
                            </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
           
            <ng-template pTemplate="paginatorleft" let-state>
                <!-- <div style="margin-left:1148px; width: 40%;display: flex;">
                    <input type="number"  style="margin-left:100px; width: 80px;" size="20" 
                    [(ngModel)]="pageNo"  (keypress)="validate($event)"/>
                    <button pButton type="button" (click)="setCurrentPage()" label="Go"></button>
                </div> -->
            </ng-template>
        </p-table>
       
</div>

